<template>
  <v-container class="w-auto mx-15" fluid>
    <v-row align="start" justify="center" class="d-flex align-self-start w-100">
      <v-col>
        <v-row style="display: grid; grid-template-columns: 52.9% 47.1%;">
          <v-col class="px-0">
            <v-card-title class="px-0">
              <v-text-field
                class="quickSearch pa-1"
                v-on:keyup.enter="tableModel.quickSearch(quickSearchText)"
                v-model="quickSearchText"
                prepend-inner-icon="mdi-magnify"
                label="Поиск"
                single-line
                hide-details
                variant="solo"
              ></v-text-field>
            </v-card-title>
          </v-col>

          <v-col class="actionsMenu pr-0">
            <v-card-title class="pa-0" style="max-height: 60px">
              <v-btn color="primary" @click="tableModel.quickSearch(quickSearchText)">
                <v-icon icon="mdi-magnify"></v-icon>{{ $t('Найти') }}</v-btn>
            </v-card-title>
          </v-col>
        </v-row>

        <AdminDataTable
          :keys-table-model="KeysTableModel"
          :table-model="tableModel"
          :subject="'config'"
          :edit="editConfig"
          no-header-borders
        />
      </v-col>
    </v-row>
    <ConfigsModal
      v-model:selectedItem="selectedItem"
      @close="closeModal"
    />
  </v-container>
</template>

<script>
import RemoteTableModel from "@/components/RemoteTableModel";
import ConfigsModal from "@/components/ConfigsModal.vue";
import api from "@/api";
import AdminDataTable from "@/components/AdminDataTable.vue";
import Input from "@intec/vue-components/form/Input.vue";

export default {
  name: "Configs",
  components: {AdminDataTable, ConfigsModal, Input},
  data() {
    const tableModel = new RemoteTableModel({
      headers: [
        { title: 'Наименование', key: 'config.name', width: '95%' },
        { title: '', key: 'actions', sortable: false },
      ],
      loader(query) {
        return api.get('/admin/configs/all', { query: JSON.stringify(query) });
      },
      options: {
        itemsPerPage: 10,
      },
    });
    return {
      tableModel: tableModel,
      KeysTableModel: tableModel.bind.headers.map(header => header.key),
      quickSearchText: '',
      totalEntries: -1,
      selectedItem: null
    };
  },
  methods: {
    reload() {
      this.tableModel.reload();
    },
    editConfig(item) {
      this.selectedItem = item;
    },
    created() {
      this.reload();
    },
    closeModal(params) {
      this.selectedItem = null;
      if (params?.reload) this.reload();
    }
  }
}
</script>

<style scoped>
:deep(.v-input) {
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
}

:deep(.v-field) {
  padding: 0;
  font-family: Abrade;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  box-shadow: none;
}

:deep(.v-field__input) {
  display: block;
  padding: 0;
  width: 48px;
  height: 34px;
  min-height: 0;
}

.sortItemTitle {
  color: rgba(0, 0, 0, 0.8);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.actionsMenu {
  display: flex;
  align-items: center;
  line-height: 44px;
  margin-bottom: 1px;
}

.quickSearch {
  min-height: 44px;
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--border-color)) !important;
  border-radius: 8px;
}

:deep(.v-field__prepend-inner) {
  padding-left: 5px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.v-field__input) {
    display: block;
    padding: 0;
    width: 48px;
    height: 34px;
    min-height: 0;
    text-align: center;
    align-content: center;
  }
}

.page-size-select {
  width: 186px !important;
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
}

.footer-font {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
</style>